module.exports = __webpack_public_path__ + "img/icon-report.6d3dbc2e.svg";